import { useState, useEffect } from 'react';

interface WindowSize {
  width: number;
  height: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

/**
 * Hook personnalisé pour détecter la taille de la fenêtre et le type d'appareil
 * @returns {WindowSize} Objet contenant la largeur, la hauteur et des booléens pour le type d'appareil
 */
export const useWindowSize = (): WindowSize => {
  // Valeurs par défaut pour le rendu côté serveur
  const defaultWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;
  const defaultHeight = typeof window !== 'undefined' ? window.innerHeight : 800;

  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: defaultWidth,
    height: defaultHeight,
    isMobile: defaultWidth < 768,
    isTablet: defaultWidth >= 768 && defaultWidth < 1024,
    isDesktop: defaultWidth >= 1024
  });

  useEffect(() => {
    // Fonction pour mettre à jour la taille de la fenêtre
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setWindowSize({
        width,
        height,
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024
      });
    };

    // S'assurer que la taille initiale est correcte
    handleResize();

    // Ajouter l'écouteur d'événement
    window.addEventListener('resize', handleResize);
    
    // Nettoyer l'écouteur d'événement
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;

